import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldTitleComponent } from './field-title.component';
import { CommonSharedModule } from 'common/common.module';


@NgModule({
  declarations: [
    FieldTitleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonSharedModule,
  ],
  exports: [FieldTitleComponent],
})
export class FieldTitleModule { }
